/*!
 * KoliBri - The accessible HTML-Standard
 */
import { h } from './index-C_ZKddLG.js';
import { S as SpanFC } from './component-DepnuZGT.js';

const TooltipFC = ({ label, badgeText, id, refFloating }) => {
    return (h("div", { class: "kol-tooltip__floating", hidden: label.length === 0, ref: refFloating }, h("div", { class: "kol-tooltip__arrow" }), h(SpanFC, { class: "kol-tooltip__content", badgeText: badgeText, id: id, label: label })));
};

export { TooltipFC as T };
//# sourceMappingURL=component-BXCnkVUN.js.map

//# sourceMappingURL=component-BXCnkVUN.js.map